import { useEffect, useId, useMemo, useRef } from 'react';
import { debounce } from 'lodash';
import { Tooltip } from 'primereact/tooltip';

// Scopes the shared cell tooltip to this grid so master/slave grids don't cross-bind.
export const useCellTooltip = () => {
  const cellTooltipId = useId();
  const cellTooltipRef = useRef<Tooltip>(null);
  const rebindCellTooltip = useMemo(
    () => debounce(() => cellTooltipRef.current?.updateTargetEvents(), 150),
    []
  );
  useEffect(() => () => rebindCellTooltip.cancel(), [rebindCellTooltip]);

  return { cellTooltipId, cellTooltipRef, rebindCellTooltip };
};
